// De keuze-opties waar een reeks antwoorden naar wijst, op ID.
//
// Nodig omdat de naam van een keuzeantwoord uit de optie moet komen en niet uit
// de opgeslagen Value: bij 'Anders, namelijk' staat daar de vrije tekst van de
// invuller, en een registratie draagt geen OptionType. Gedeeld door de
// outputtooltip (useOutputFieldResults) en de keuzegrafiek van een activiteit
// (EventMultipleData).
//
// Bewust op ID en niet per organisatie: de antwoorden komen van
// fetchHierarchyData (of de openbare poort) en kunnen uit gekoppelde projecten
// komen, met hun eigen opties. Wie het antwoord mocht zien, mag de naam van de
// optie zien; meer dan die ID's wordt niet gelezen.

import { db } from '../../firebase/config'

/** Firestore staat in een `in`-filter hooguit 30 waarden toe. */
const IN_LIMIT = 30

/**
 * @param {Array<{ OptionID?: string }>} records
 * @returns {Promise<Object<string, object>>} MultipleQuestionOptions op ID
 */
const fetchOptionsById = async (records) => {
    const ids = [...new Set((records || []).map(r => r?.OptionID).filter(id => typeof id === 'string' && id))]
    const chunks = []
    for (let i = 0; i < ids.length; i += IN_LIMIT) chunks.push(ids.slice(i, i + IN_LIMIT))
    const snaps = await Promise.all(chunks.map(chunk =>
        db.collection('MultipleQuestionOptions').where('ID', 'in', chunk).get()))
    const byId = {}
    snaps.forEach(snap => snap.docs.forEach(d => { byId[d.data().ID] = d.data() }))
    return byId
}

export default fetchOptionsById
